export enum AccountType {
	LOAN = 'loan',
}
